<h2 mat-dialog-title>
  <mat-icon [color]="data.type === 'downgrade' ? 'warn' : 'accent'">{{ data.type === 'downgrade' ? 'warning' : 'info' }}</mat-icon>
  {{ data.type === 'downgrade' ? ('FirmwareUpdate.DowngradeTitle' | translate) : ('FirmwareUpdate.ReinstallTitle' | translate) }}
</h2>
<mat-dialog-content>
  <p>{{ data.type === 'downgrade' ? ('FirmwareUpdate.DowngradeMessage' | translate) : ('FirmwareUpdate.ReinstallMessage' | translate) }}</p>
  <div class="device-list">
    <div *ngFor="let d of data.devices" class="device-item">
      <span class="device-mac">{{ d.mac }}</span>
      <span class="device-version">v{{ d.currentVersion }} → v{{ d.targetVersion }}</span>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">{{ 'Shared.Cancel' | translate }}</button>
  <button mat-raised-button [color]="data.type === 'downgrade' ? 'warn' : 'primary'" [mat-dialog-close]="true">
    {{ data.type === 'downgrade' ? ('FirmwareUpdate.ConfirmDowngrade' | translate) : ('FirmwareUpdate.ConfirmReinstall' | translate) }}
  </button>
</mat-dialog-actions>
